export enum WinnerPayoutDateFilterTypes {
  DrawDate = 1,
  PayoutDate = 2
}
